import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography, Button } from "@material-ui/core";
import { Field, Form, Formik } from "formik";

import { cleanCNPJ } from "../../../../utils/stringManipulations";
import { validateCpfCnpj } from "../../../../utils/inputValidations";

import {
  OutlineTextField,
  OutlineSearchable,
  OutlineCPForCNPJ,
} from "../../../FormikCustoms";
import FormikFileUploaderAjax from "../../../FormikCustoms/FormikFileUploaderAjax";

import useStyles from "./styles";
// import { validateCNH } from "../../../../utils/validateCNH";

function TabData(props) {
  const {
    value,
    index,
    setTab,
    editingItem,
    setEditingItem,
    products,
    branches,
    plants,
    getDriver,
    selectedDriver,
    clients,
    transporters,
    getClientByDocument,
    loadPlantByDocumentNumber,
    loadBranchByPlant,
    loadProductsByPlant,
    loadPlants,
    ...other
  } = props;
  const classes = useStyles();
  const [feedback, setFeedback] = useState({});
  const [client, setClient] = useState(null);
  const [searchingClient, setSearchingClient] = useState(false);
  const [plant, setPlant] = useState(null);
  const [branch, setBranch] = useState(null);

  useEffect(() => {
    if (branches.length === 1 && editingItem.branch !== branches[0].value) {
      editingItem.branch = branches[0].value;
      editingItem.branchLabel = branches[0].label;
      setBranch(branches[0]);
      loadPlants(branches[0].value);
    }
  }, [branches, editingItem.branch, editingItem.branchLabel, loadPlants]);

  useEffect(() => {
    if (plants.length === 1) {
      editingItem.plant = plants[0].value;
      editingItem.plantLabel = plants[0].label;
      setPlant(plants[0]);
    } else {
      setPlant(null);
    }
  }, [
    plants,
    branches,
    editingItem.plant,
    editingItem.plantLabel,
    editingItem.loadingType,
  ]);

  useEffect(() => {
    if (plants.length && editingItem.cnpjDestino && !editingItem.product) {
      loadBranchByPlant({
        idLoadType: editingItem.loadingType,
        idPlant: plants[0].value,
      });
      loadProductsByPlant({
        idLoadType: editingItem.loadingType,
        idPlant: plants[0].value,
      });
    }
  }, [plants, branches.length, editingItem.loadingType, editingItem.cnpjDestino, editingItem.product, loadBranchByPlant, loadProductsByPlant]);

  const handleOnFeedback = () => {
    if (feedback.success) {
      //   handleOnclose();
    } else {
      setFeedback({});
    }
  };

  const handlePlantDocumentEntered = async (values, setFieldValue) => {
    if (values.cnpjDestino && cleanCNPJ(values.cnpjDestino) !== '') {
      loadPlantByDocumentNumber({
        idLoadType: editingItem.loadingType,
        documentNumber: values.cnpjDestino,
      });
      setEditingItem({...editingItem, cnpjDestino: values.cnpjDestino});
    }
  };

  const handleDocumentEntered = async (values, setFieldValue) => {
    const clientDocument = cleanCNPJ(values.cliente);
    if (clientDocument.length === 11 || clientDocument.length === 14) {
      const client = await getClientByDocument({
        documentNumber: clientDocument,
        includeFarms: 1,
      });
      setClient(null);
      setSearchingClient(true);
      if (client) {
        setFieldValue("nameClient", client.name);
        setClient(client);
      } else {
        if (!values.nameClient) {
          setFieldValue("nameClient", "");
        }
      }
    }
    setSearchingClient(false);
  };

  const canEditName = (values) => {
    const clientDocument = cleanCNPJ(values.cliente);
    if (searchingClient) return true;
    if (clientDocument.length !== 11 && clientDocument.length !== 14)
      return true;
    if (client) return true;

    return false;
  };

  const handleOnSubmit = async (values, setSubmitting) => {
    values.cliente = cleanCNPJ(values.cliente);
    values.plantLabel = editingItem.plantLabel;
    values.branchLabel = editingItem.branchLabel;
    values.productLabel = editingItem.productLabel;
    values.loadingType = editingItem.loadingType;
    values.nfImg = editingItem.nfImg;
    values.truckDocumentImg = editingItem.truckDocumentImg;
    values.driverLicenseImg = editingItem.driverLicenseImg;
    values.transporterDocumentNumber = cleanCNPJ(
      values.transporterDocumentNumber
    );
    values.driver_id = selectedDriver.id ? selectedDriver.id : null;
    values.driver = selectedDriver.name ? selectedDriver.name : values.driver;
    setEditingItem(values);
    setSubmitting(false);
    setTab(2);
  };

  const handleFileUpload = (fieldName, data) => {
    setEditingItem({
      ...editingItem,
      [fieldName]: data,
    });
  };

  const validateForm = (values) => {
    if (clients.length === 1 && !values.cliente) {
      values.cliente = clients[0].value;
      values.nameClient = clients[0].name;
    }

    if (transporters.length === 1 && !values.transporterDocumentNumber) {
      values.transporterDocumentNumber = transporters[0].value;
    }

    if (branches.length === 1 && !values.branch) {
      values.branch = branches[0].value;
      values.branchLabel = branches[0].label;
    }

    if (plants.length === 1 && !values.plant) {
      values.plant = plants[0].value;
      values.plantLabel = plants[0].label;
    }

    const errors = {};

    if (!values.cliente) {
      errors.cliente =
        editingItem.loadingType === 1
          ? "CPF/CNPJ do Cliente precisa ser válido"
          : editingItem.originType === "cargill"
          ? "CNPJ da Unidade Cargill precisa ser válido"
          : "CPF/CNPJ do cliente precisa ser válido";
    }

    if (values.cliente && !validateCpfCnpj(values.cliente)) {
      errors.cliente =
        editingItem.loadingType === 1
          ? "CPF/CNPJ do Cliente precisa ser válido"
          : editingItem.originType === "cargill"
          ? "CNPJ da Unidade Cargill de Origem precisa ser válido"
          : "CPF/CNPJ do Cliente precisa ser válido";
    }

    if (!values.volume){
      errors.volume = "Volume é necessário";
    }else if (values.volume < 100){
      errors.volume = "Volume não poderá ser inferior a 100";
    }

    if (!values.product) {
      errors.product = "Produto é necessário";
    }
    if (!values.nameClient) {
      errors.nameClient =
        editingItem.loadingType === 1
          ? "Nome do Cliente é necessário"
          : editingItem.originType === "cargill"
          ? "Nome da Unidade Cargill de Origem precisa ser válido"
          : "Nome do Cliente é necessário";
    }

    if (!values.plant) {
      errors.plant =
        editingItem.loadingType === 1
          ? "Planta/Fábrica para Carga é necessária"
          : "Planta/Fábrica para Descarga é necessária";
    }
    if (!values.branch) {
      errors.branch =
        editingItem.loadingType === 1
          ? "Unidade Cargill de Carga é necessária"
          : "Unidade Cargill de Descarga é necessária";
    }

    if (!values.driverPlate) {
      errors.driverPlate = "Placa do Caminhão é necessária";
    }
    if (!values.driver && !selectedDriver.name) {
      errors.driver = "Nome do Motorista é necessário";
    }

    if (!values.driverLicense) {
      errors.driverLicense = "CNH é necessária";
    }

    /*const isEnableCNHValidation = process.env.REACT_APP_ENABLE_CNH_VALIDATION ?? true;
    const isCnhValid =  isEnableCNHValidation ? validateCNH(values.driverLicense) : true;

    if (values.driverLicense && !isCnhValid) {
      errors.driverLicense = "CNH do Motorista precisa ser válida";
    }*/

    if (values.cnpjDestino && !validateCpfCnpj(values.cnpjDestino)) {
      errors.cnpjDestino =
        editingItem.loadingType === 1
          ? "CNPJ Unidade Cargill de Carga precisa ser válido"
          : "CNPJ Unidade Cargill de Descarga precisa ser válido";
    }

    if (
      values.transporterDocumentNumber &&
      !validateCpfCnpj(values.transporterDocumentNumber)
    ) {
      errors.transporterDocumentNumber =
        "CNPJ da Transportadora precisa ser válido";
    }

    return errors;
  };

  return (
    <>
      <Box
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      />
      {value === index && (
        <>
          <Box
            height="100%"
            bgcolor="white"
            width="100%"
            justifyContent="center"
            alignItems="center"
            display="flex"
            flexDirection="column"
            p={3}
          >
            {!Object.keys(feedback).length ? (
              <Formik
                initialValues={{
                  id: editingItem.id ?? null,
                  cliente: editingItem.cliente ?? "",
                  product: editingItem.product ?? 0,
                  volume: editingItem.volume ?? "",
                  nf: editingItem.nf ?? "",
                  serialNumber: editingItem.serialNumber ?? "",
                  nameClient: editingItem.nameClient ?? "",
                  driverPlate: editingItem.driverPlate ?? "",
                  driver: editingItem.driver ?? "",
                  driverLicense: editingItem.driverLicense ?? "",
                  branch: editingItem.branch ?? "",
                  cnpjDestino: editingItem.cnpjDestino ?? "",
                  plant: editingItem.plant ?? "",
                  nfImg: editingItem.nfImg ?? null,
                  truckDocumentImg: editingItem.truckDocumentImg ?? null,
                  driverLicenseImg: editingItem.driverLicenseImg ?? null,
                  transporterDocumentNumber:
                    editingItem.transporterDocumentNumber ?? "",
                }}
                validate={(values) => validateForm(values)}
                onSubmit={(values, { setSubmitting }) =>
                  handleOnSubmit(values, setSubmitting)
                }
              >
                {({
                  setFieldValue,
                  submitForm,
                  errors,
                  isSubmitting,
                  values,
                }) => (
                  <Form>
                    <Grid container spacing={3} className={classes.inputBox}>
                      <Grid item md={12} xs={12}>
                        <Box className={classes.inputBoxTitle}>
                          2.1 Dados do Cliente
                        </Box>
                      </Grid>

                      {clients.length ? (
                        <Grid item md={12} xs={12}>
                          <Field
                            component={OutlineSearchable}
                            name="cliente"
                            type="tel"
                            options={clients}
                            placeholder="Selecionar Cliente *"
                            disabled={clients.length === 1}
                            data-cy="client-field"
                            id="client-field"
                            defaultValue={
                              clients.length === 1 ? clients[0] : null
                            }
                            onChange={(selectedOption) => {
                              setEditingItem({
                                ...editingItem,
                                cliente: selectedOption.value,
                                nameClient: selectedOption.name,
                              });
                              setFieldValue("cliente", selectedOption.value);
                              setFieldValue("nameClient", selectedOption.name);
                            }}
                          />
                        </Grid>
                      ) : (
                        <Grid item md={4} xs={12}>
                          <Field
                            component={OutlineCPForCNPJ}
                            name="cliente"
                            type="tel"
                            data-cy="client-document"
                            id="client-document"
                            label={
                              editingItem.loadingType === 1
                                ? "CPF/CNPJ do Cliente *"
                                : editingItem.originType === "cargill"
                                ? "CNPJ da Unidade Cargill de Origem * "
                                : "CPF/CNPJ do Cliente *"
                            }
                            value={values.cliente ? values.cliente : ""}
                            onFocus={() => setSearchingClient(true)}
                            onBlur={() =>
                              handleDocumentEntered(values, setFieldValue)
                            }
                          />
                        </Grid>
                      )}
                      {!clients.length && (
                        <Grid item md={8} xs={12}>
                          <Field
                            component={OutlineTextField}
                            name="nameClient"
                            type="text"
                            data-cy="client-name-client"
                            id="client-name-client"
                            label={
                              editingItem.loadingType === 1
                                ? "Nome do Cliente *"
                                : editingItem.originType === "cargill"
                                ? "Nome da Unidade Cargill de Origem * "
                                : "Nome do Cliente *"
                            }
                            value={values.nameClient ? values.nameClient : ""}
                            disabled={canEditName(values)}
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={3} className={classes.inputBox}>
                      <Grid item md={12} xs={12}>
                        <Box className={classes.inputBoxTitle}>
                            2.2 Dados do Produto
                        </Box>
                      </Grid>
                      {
                          editingItem.loadingType === 2 && (
                            <>
                              <Grid item md={3} xs={12}>
                                <Field
                                  component={OutlineTextField}
                                  name="nf"
                                  type="number"
                                  data-cy="document-tax-field"
                                  id="document-tax-field"
                                  placeholder="Número Nota Fiscal"
                                  label={values.nf && "Número Nota Fiscal"}
                                  value={values.nf ? values.nf : ""}
                                />
                              </Grid>
                              <Grid item md={3} xs={12}>
                                <Field
                                  component={OutlineTextField}
                                  name="serialNumber"
                                  type="number"
                                  data-cy="document-tax-serial-field"
                                  id="document-tax-serial-field"
                                  placeholder="Número de Série"
                                  label={values.serialNumber && "Número de Série"}
                                  value={values.serialNumber ? values.serialNumber : ""}
                                />
                              </Grid>
                            </>
                          )
                      }

                      <Grid item md={3} xs={12}>
                        <Field
                          component={OutlineTextField}
                          name="volume"
                          type="text"
                          data-cy="volume-field"
                          id="volume-field"
                          label="Volume (unidade Kg)"
                          value={values.volume ? values.volume : ""}
                          mask = "99999"
                          maskplaceholder=""
                        />

                      </Grid>
                      <Grid item md={3} xs={12}>
                        <Field
                          component={OutlineSearchable}
                          name="product"
                          placeholder="Selecionar Produto *"
                          data-cy="product-field"
                           id="product-field"
                          options={products}
                          value={
                            values.product && {
                              label: editingItem.productLabel,
                              value: values.product,
                            }
                          }
                          onChange={(selectedOption) => {
                            setEditingItem({
                              ...editingItem,
                              product: selectedOption.value,
                              productLabel: selectedOption.label,
                            });
                            setFieldValue("product", selectedOption.value);
                          }}
                        />
                      </Grid>
                        {
                          editingItem.loadingType === 2 && (
                            <>
                              <Grid item md={12} xs={12}>
                                <Box className={classes.inputBoxSubTitle}>Anexos</Box>
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <Field
                                  component={FormikFileUploaderAjax}
                                  path={`v1/Schedulings/upload/${2}`}
                                  name="nfImg"
                                  data-cy="nfimg-field"
                                  id="nfimg-field"
                                  label="Nota(s) Fiscal(is)"
                                  value={values.nfImg}
                                  onComplete={(data) => handleFileUpload("nfImg", data)}
                                  onClear={() => handleFileUpload("nfImg", null)}
                                />
                              </Grid>
                            </>
                          )
                      }
                    </Grid>
                    <Grid container spacing={3} className={classes.inputBox}>
                      <Grid item md={12} xs={12}>
                        <Box className={classes.inputBoxTitle}>
                          2.3 Dados da Unidade Cargill
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Field
                          name="branch"
                          placeholder={
                            editingItem.loadingType === 1
                              ? "Unidade Cargill de Carga *"
                              : "Unidade Cargill de Descarga *"
                          }
                          disabled={!values.product}
                          component={OutlineSearchable}
                          options={branches}
                          data-cy="branch-field"
                          id="branch-field"
                          value={
                            (values.branch || branch) && {
                              label: editingItem.branchLabel || branch.label,
                              value: values.branch || branch.value,
                            }
                          }
                          onChange={(selectedOption) => {
                            setEditingItem({
                              ...editingItem,
                              branch: selectedOption.value,
                              branchLabel: selectedOption.label,
                            });
                            setFieldValue("branch", selectedOption.value);
                          }}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Field
                          as="select"
                          name="plant"
                          data-cy="plant-field"
                          id="plant-field"
                          placeholder={
                            editingItem.loadingType === 1
                              ? "Planta/Fábrica para Carga *"
                              : "Planta/Fábrica para Descarga *"
                          }
                          disabled={!values.product}
                          component={OutlineSearchable}
                          options={plants}
                          value={
                            (values.plant || plant) && {
                              label: editingItem.plantLabel || plant.label,
                              value: values.plant || plant.value,
                            }
                          }
                          onChange={(selectedOption) => {
                            setEditingItem({
                              ...editingItem,
                              plant: selectedOption.value,
                              plantLabel: selectedOption.label,
                            });
                            setFieldValue("plant", selectedOption.value);
                          }}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Field
                          component={OutlineTextField}
                          mask="99.999.999/9999-99"
                          name="cnpjDestino"
                          data-cy="cnpj-field"
                          id="cnpj-field"
                          type="text"
                          label={
                            editingItem.loadingType === 1
                              ? "CNPJ Unidade Cargill de Carga"
                              : "CNPJ Unidade Cargill de Descarga"
                          }
                          onBlur={() => {
                            handlePlantDocumentEntered(values, setFieldValue);
                          }}
                          value={values.cnpjDestino ? values.cnpjDestino : ""}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} className={classes.inputBox}>
                      <Grid item md={12} xs={12}>
                        <Box className={classes.inputBoxTitle}>
                          2.4 Dados de Transporte
                        </Box>
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <Field
                          component={OutlineTextField}
                          name="driverPlate"
                          mask="*******"
                          type="text"
                          data-cy="driver-field"
                          id="driver-field"
                          placeholder="Placa do Caminhão *"
                          label={values.driverPlate && "Placa do Caminhão"}
                          value={
                            values.driverPlate
                              ? values.driverPlate.toUpperCase()
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <Field
                          component={OutlineTextField}
                          type="text"
                          mask="99999999999"
                          maskplaceholder=""
                          name="driverLicense"
                          data-cy="cnh-field"
                          id="cnh-field"
                          placeholder="CNH Motorista *"
                          onBlur={() => {
                            values.driverLicense &&
                              getDriver(values.driverLicense);
                          }}
                          label={values.driverPlate && "CNH Motorista"}
                          selected={false}
                          value={
                            values.driverLicense ? values.driverLicense : ""
                          }
                        />
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <Field
                          component={OutlineTextField}
                          name="driver"
                          disabled={!!selectedDriver.name}
                          data-cy="driver-name-field"
                          id="driver-name-field"
                          label="Nome do Motorista *"
                          selected={false}
                          value={
                            selectedDriver.name
                              ? selectedDriver.name
                              : values.driver
                          }
                        />
                      </Grid>
                      <Grid item md={3} xs={12}>
                        {transporters.length ? (
                          <Field
                            component={OutlineSearchable}
                            name="transporterDocumentNumber"
                            type="tel"
                            data-cy="transporter-field"
                            id="transporter-field"
                            options={transporters}
                            placeholder="Selecionar Transportadora"
                            disabled={transporters.length === 1}
                            defaultValue={
                              transporters.length === 1 ? transporters[0] : null
                            }
                            onChange={(selectedOption) => {
                              setEditingItem({
                                ...editingItem,
                                transporterDocumentNumber: selectedOption.value,
                              });
                              setFieldValue(
                                "transporterDocumentNumber",
                                selectedOption.value
                              );
                            }}
                          />
                        ) : (
                          <Field
                            component={OutlineTextField}
                            name="transporterDocumentNumber"
                            label="CNPJ da Transportadora"
                            mask="99.999.999/9999-99"
                            data-cy="cnpj-transporter-field"
                            id="cnpj-transporter-field"
                            selected={false}
                            value={
                              values.transporterDocumentNumber
                                ? values.transporterDocumentNumber
                                : ""
                            }
                          />
                        )}
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Box className={classes.inputBoxSubTitle}>Anexos</Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Field
                          component={FormikFileUploaderAjax}
                          path={`v1/Schedulings/upload/${1}`}
                          name="driverLicenseImg"
                          label="CNH do Motorista"
                          data-cy="cnh-trucker-field"
                          id="cnh-trucker-field"
                          value={values.driverLicenseImg}
                          onComplete={(data) =>
                            handleFileUpload("driverLicenseImg", data)
                          }
                          onClear={() =>
                            handleFileUpload("driverLicenseImg", null)
                          }
                        />
                      </Grid>
                      <Grid item md={9} xs={12}></Grid>
                      <Grid item md={4} xs={12}>
                        <Field
                          component={FormikFileUploaderAjax}
                          path={`v1/Schedulings/upload/${3}`}
                          name="truckDocumentImg"
                          data-cy="trucker-cnh-img-field"
                          id="trucker-cnh-img-field"
                          label="Documento do Caminhão"
                          value={values.truckDocumentImg}
                          onComplete={(data) =>
                            handleFileUpload("truckDocumentImg", data)
                          }
                          onClear={() =>
                            handleFileUpload("truckDocumentImg", null)
                          }
                        />
                      </Grid>
                    </Grid>
                    <Box
                      width="100%"
                      justifyContent="space-between"
                      alignItems="flex-end"
                      display="flex"
                      flexDirection="row"
                      p={2}
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        autoFocus
                        data-cy="back-button"
                        id="back-button"
                        size="large"
                        className={classes.backButton}
                        onClick={() => {
                          setTab(0);
                        }}
                      >
                        Voltar
                      </Button>
                      <Button
                        color="primary"
                        variant="contained"
                        autoFocus
                        data-cy="foward-button"
                        id="foward-button"
                        size="large"
                        className={classes.nextButton}
                        disabled={isSubmitting}
                        onClick={submitForm}
                      >
                        Avançar
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            ) : (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h5">{feedback.message}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      height: 56,
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      onClick={handleOnFeedback}
                      variant="contained"
                      data-cy="retry-btn"
                      id="retry-btn"
                      color="primary"
                      style={{ minWidth: "50%" }}
                      size="large"
                    >
                      {feedback.success ? "Voltar" : "Tentar novamente"}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            )}
          </Box>
        </>
      )}
    </>
  );
}

TabData.propTypes = {
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  setTab: PropTypes.func.isRequired,
  editingItem: PropTypes.object,
  setEditingItem: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  plants: PropTypes.array.isRequired,
  clients: PropTypes.array.isRequired,
  getClientByDocument: PropTypes.func.isRequired,
  loadPlantByDocumentNumber: PropTypes.func.isRequired,
  loadBranchByPlant: PropTypes.func.isRequired,
  loadProductsByPlant: PropTypes.func.isRequired,
};

export default TabData;
